import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';
import { InputSize } from '@shared/types/common/input';

export const styles = ({ spacing }: Theme) => {
  return createStyles({
    root: {
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: `${colours.error[600]} !important`,
      },
    },
    adornmentText: {
      alignItems: 'center',
      color: colours.neutral[500],
      display: 'flex',
      fontSize: 14,
      lineHeight: '20px',
      whiteSpace: 'nowrap',
    },
    endAdornment: {
      gap: 6,
    },
    rootFullWidth: {
      width: '100%',
    },
    input: {
      backgroundColor: colours.solid.white,

      '&.Mui-disabled': {
        backgroundColor: colours.grey[200], // TODO: Change after palette updated
        boxShadow: 'none',
        color: colours.neutral[400], // TODO: Change after palette updated
        cursor: 'not-allowed',
        pointerEvents: 'none',
        userSelect: 'none',

        '&.Mui-disabled > input': {
          color: 'currentColor',
        },

        '& > .MuiOutlinedInput-notchedOutline': {
          borderColor: colours.grey[200], // TODO: Change after palette updated
        },
      },

      '&:hover': {
        '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: colours.neutral[400], // TODO: Change after palette updated
        },
      },

      '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${colors.blue.dark} !important`,
        borderWidth: `1px !important`,
        boxShadow: '0px 0px 0px 4px rgba(50, 77, 252, 0.1);',
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
      },

      '&.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        boxShadow: '0px 0px 0px 4px rgb(217 45 32 / 8%)',
      },

      '&.MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: `${colours.error[600]} !important`,
        boxShadow: '0px 0px 0px 4px rgb(217 45 32 / 8%)',
      },

      // '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      //   borderColor: `${colors.grey.main} !important`,
      // },
    },
    labelRoot: {
      color: colours.neutral[900],
      fontSize: 14,
      fontWeight: 500,
      marginBottom: spacing(2),
    },
    label: {},
    labelError: {
      color: '#C52810 !important', //TODO replace after new palette creating
    },
    helperText: {
      paddingTop: spacing(1),
    },

    // Sizes
    [InputSize.small]: {
      height: 32,
    },
    [InputSize.mediumLegacy]: {
      height: 36,
    },
    [InputSize.medium]: {
      height: 40,
    },
    [InputSize.large]: {
      height: 48,
    },
  });
};
